<template lang="html">
  <div
    id="detailinfo"
    class="store-info"
    v-if="newStoreInfo"
    @click="gotoShopDetail(storeInfo().businessId)"
  >
    <img
      class="store-photo"
      :src="storeInfo().photo | avatar(120, 120)"
      alt=""
    />
    <div class="store-name pf-medium">{{ storeInfo().shortName }}</div>
    <img class="store-todetail" src="@/assets/images/bg_to_store.png" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const { businessId, cmmdtyUseBusiness = [] } = this.product
    let newStoreInfo = cmmdtyUseBusiness.find(
      x => +x.businessId === +businessId
    )
    if (newStoreInfo) {
      if (+newStoreInfo.scoreAvg === 0) newStoreInfo.scoreAvg = 5
    } else {
      if (cmmdtyUseBusiness.length > 0) {
        newStoreInfo = cmmdtyUseBusiness[0]
      }
    }
    return {
      newStoreInfo
    }
  },
  mounted() {
    if (this.$refs.star) {
      this.$refs.star.style.width =
        100 * (this.storeInfo().scoreAvg / 5.0) + '%'
    }
  },
  updated() {
    if (this.$refs.star) {
      this.$refs.star.style.width =
        100 * (this.storeInfo().scoreAvg / 5.0) + '%'
    }
  },
  methods: {
    storeInfo() {
      // let store
      // for (let item of this.product.cmmdtyUseBusiness) {
      //   if (item.businessId == this.product.businessId.toString()) {
      //     store = item
      //     if (store.scoreAvg == 0) store.scoreAvg = 5
      //     break
      //   }
      // }
      // return store
      return this.newStoreInfo
    },
    gotoShopDetail(id) {
      // this.$router.push({
      //   path: '/recovery-detail',
      //   query: {shopId: id, kwtarget: 'blank'},
      // })
      location.href = '//life.cekid.com/h5/shop?businessId=' + id
    },
    gotoMap() {
      const store = this.storeInfo()
      const lat = store.latitude
      const lng = store.longitude
      const desc = store.shortName
      const address = store.addressStreet
      this.$router.push(
        `/map?lng=${lng}&lat=${lat}&desc=${desc}&address=${address}`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.store-info {
  margin-top: rem(20px);
  padding: rem(24px) rem(30px);
  background: white;
  display: flex;
  align-items: center;

  .store-photo {
    width: rem(78px);
    height: rem(78px);
    border-radius: rem(8px);
    border: 1px solid #e8e8e8;
  }
  .store-name {
    margin-left: rem(16px);
    width: rem(436px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: rem(28px);
    color: #262626;
  }
  .store-todetail {
    width: rem(160px);
    height: rem(60px);
  }
}
</style>
